export default __webpack_public_path__ + "static/media/MissingPersonalData.d792d4bc.svg";